import { revenueQueryTypes } from '../../constants/revenue';
import { createFilterReducer } from '../filter';
import {
  revenuePaymentFilterActions,
  revenuePaymentFilterActionsPrefix,
} from '../../constants/filter';
import { commonEvents, dateColumns, paymentAmounts } from '../../constants/event';

const filterReducer = createFilterReducer(revenuePaymentFilterActionsPrefix);

const composeInitialState = {
  queryType: revenueQueryTypes.REVENUE,
  groupColumn: dateColumns.DAY,
  splitColumn: undefined,
  amountFields: [],
  amountField: undefined,
  paymentFilter: filterReducer(undefined, {}),
};

const compose = (state = composeInitialState, action) => {
  switch (action.type) {
    case 'FETCH_METAINF_SUCCESS': {
      // условие сделано, чтобы если событие Payment не получено в метаинфе, то присваиваем initial state
      const fields = action.metainf.paths[commonEvents.PAYMENT]
        ? paymentAmounts
            .map((p) =>
              action.metainf.paths[commonEvents.PAYMENT].find(({ path }) => `event.${p}` === path)
            )
            .filter((e) => !!e)
        : [];

      return {
        ...state,
        amountFields: fields,
        amountField: fields[0],
      };
    }

    case 'SET_AMOUNT_FIELD':
      return {
        ...state,
        amountField: action.amountField,
      };

    case 'REVENUE_COMPOSE_SET_GROUP_COLUMN':
      return {
        ...state,
        groupColumn: action.groupColumn,
      };

    case 'REVENUE_COMPOSE_SET_SPLIT_COLUMN':
      return {
        ...state,
        splitColumn: action.splitColumn,
      };

    case 'CHANGE_REVENUE_QUERY_TYPE': {
      let { groupColumn, splitColumn } = state;
      const payersAndARPU = [revenueQueryTypes.ARPU, revenueQueryTypes.PAYERS];

      const isResetOptions = !(
        (payersAndARPU.includes(action.queryType) && payersAndARPU.includes(state.queryType)) ||
        (!payersAndARPU.includes(action.queryType) && !payersAndARPU.includes(state.queryType))
      );

      if (isResetOptions) {
        groupColumn = dateColumns.DAY;
        splitColumn = undefined;
      }

      return {
        ...state,
        queryType: action.queryType,
        groupColumn,
        splitColumn,
      };
    }

    case revenuePaymentFilterActions.ADD_FILTER_CLAUSE:
    case revenuePaymentFilterActions.REMOVE_FILTER:
    case revenuePaymentFilterActions.REMOVE_FILTER_CLAUSE:
    case revenuePaymentFilterActions.SET_FILTER_CLAUSE_FIELD:
    case revenuePaymentFilterActions.SET_FILTER_CLAUSE_VALUE:
    case revenuePaymentFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case revenuePaymentFilterActions.SET_FILTER_CLAUSE_OPERATOR:
      return {
        ...state,
        paymentFilter: filterReducer(state.paymentFilter, action),
      };

    default:
      return state;
  }
};

export default compose;

export const getAmountField = (state) => state.amountField;

export const getAmountFields = (state) => state.amountFields;

export const getGroupColumn = (state) => state.groupColumn;

export const getSplitColumn = (state) => state.splitColumn;

export const getQueryType = (state) => state.queryType;

export const getPaymentFilter = (state) => state.paymentFilter;
